import { styles } from './styles';

export const LayoutDefault = (): JSX.Element => (
  <svg
    width="69"
    height="32"
    viewBox="0 0 69 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 3C1 1.89543 1.89543 1 3 1H66C67.1046 1 68 1.89543 68 3V29C68 30.1046 67.1046 31 66 31H3C1.89543 31 1 30.1046 1 29V3Z"
      fill={styles.background}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 0H66C67.6569 0 69 1.34315 69 3V29C69 30.6569 67.6569 32 66 32H3C1.34314 32 0 30.6569 0 29V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V29C1 30.1046 1.89543 31 3 31H66C67.1046 31 68 30.1046 68 29V3C68 1.89543 67.1046 1 66 1H3Z"
      fill={styles.border}
    />
    <path
      d="M5.5 6.5C5.5 5.39543 6.39543 4.5 7.5 4.5H61.5C62.6046 4.5 63.5 5.39543 63.5 6.5V12.5C63.5 13.6046 62.6046 14.5 61.5 14.5H7.5C6.39543 14.5 5.5 13.6046 5.5 12.5V6.5Z"
      fill={styles.element}
    />
    <path
      d="M34.2143 7C34.2143 6.72386 34.4381 6.5 34.7143 6.5H45.7143C45.9904 6.5 46.2143 6.72386 46.2143 7V8C46.2143 8.27614 45.9904 8.5 45.7143 8.5H34.7143C34.4381 8.5 34.2143 8.27614 34.2143 8V7Z"
      fill={styles.background}
    />
    <path
      d="M8.71429 8.5C8.71429 8.22386 8.93814 8 9.21429 8H20.2143C20.4904 8 20.7143 8.22386 20.7143 8.5V10.5C20.7143 10.7761 20.4904 11 20.2143 11H9.21429C8.93814 11 8.71429 10.7761 8.71429 10.5V8.5Z"
      fill={styles.background}
    />
    <path
      d="M50.7143 6.5C50.7143 6.22386 50.9382 6 51.2143 6H57.2143C57.4904 6 57.7143 6.22386 57.7143 6.5V12.5C57.7143 12.7761 57.4904 13 57.2143 13H51.2143C50.9382 13 50.7143 12.7761 50.7143 12.5V6.5Z"
      fill={styles.background}
    />
    <path
      d="M34.2143 11C34.2143 10.7239 34.4381 10.5 34.7143 10.5H45.7143C45.9904 10.5 46.2143 10.7239 46.2143 11V12C46.2143 12.2761 45.9904 12.5 45.7143 12.5H34.7143C34.4381 12.5 34.2143 12.2761 34.2143 12V11Z"
      fill={styles.background}
    />
    <path
      d="M30.6857 9.5C30.6857 11.433 29.1187 13 27.1857 13C25.2527 13 23.6857 11.433 23.6857 9.5C23.6857 7.567 25.2527 6 27.1857 6C29.1187 6 30.6857 7.567 30.6857 9.5Z"
      fill={styles.background}
    />
    <path
      d="M5.5 19.5C5.5 18.3954 6.39543 17.5 7.5 17.5H61.5C62.6046 17.5 63.5 18.3954 63.5 19.5V25.5C63.5 26.6046 62.6046 27.5 61.5 27.5H7.5C6.39543 27.5 5.5 26.6046 5.5 25.5V19.5Z"
      fill={styles.element}
    />
    <path
      d="M34.2143 20C34.2143 19.7239 34.4381 19.5 34.7143 19.5H45.7143C45.9904 19.5 46.2143 19.7239 46.2143 20V21C46.2143 21.2761 45.9904 21.5 45.7143 21.5H34.7143C34.4381 21.5 34.2143 21.2761 34.2143 21V20Z"
      fill={styles.background}
    />
    <path
      d="M8.71429 21.5C8.71429 21.2239 8.93814 21 9.21429 21H20.2143C20.4904 21 20.7143 21.2239 20.7143 21.5V23.5C20.7143 23.7761 20.4904 24 20.2143 24H9.21429C8.93814 24 8.71429 23.7761 8.71429 23.5V21.5Z"
      fill={styles.background}
    />
    <path
      d="M23.7143 19.5C23.7143 19.2239 23.9381 19 24.2143 19H30.2143C30.4904 19 30.7143 19.2239 30.7143 19.5V25.5C30.7143 25.7761 30.4904 26 30.2143 26H24.2143C23.9381 26 23.7143 25.7761 23.7143 25.5V19.5Z"
      fill={styles.background}
    />
    <path
      d="M34.2143 24C34.2143 23.7239 34.4381 23.5 34.7143 23.5H45.7143C45.9904 23.5 46.2143 23.7239 46.2143 24V25C46.2143 25.2761 45.9904 25.5 45.7143 25.5H34.7143C34.4381 25.5 34.2143 25.2761 34.2143 25V24Z"
      fill={styles.background}
    />
    <path
      d="M57.6857 22.5C57.6857 24.433 56.1187 26 54.1857 26C52.2527 26 50.6857 24.433 50.6857 22.5C50.6857 20.567 52.2527 19 54.1857 19C56.1187 19 57.6857 20.567 57.6857 22.5Z"
      fill={styles.background}
    />
  </svg>
);
